import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  clickEventUpdated: ['event'],
  reset: []
})

export const ClickTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  lngLat: {},
  point: {}
})

// Redux reducers
export const clickEventUpdated = (state, { event }) => {
  const { lngLat, point } = event
  return state.merge({ lngLat, point })
}

export const clickReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.CLICK_EVENT_UPDATED]: clickEventUpdated,
  [Types.RESET]: clickReset
})



// WEBPACK FOOTER //
// ./src/redux/clickRedux.js